import { Draggable, type DraggableProvided } from "@hello-pangea/dnd"
import styled, { type CSSProperties } from "styled-components"

import { ProjectConstructor } from "#customTypes/composedTypes/projectTypes"

const SLabel = styled.div`
  position: absolute;
  left: 8px;
  right: 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  transform: translateY(-4px);
`

const createDayTicks = (daysToComplete: number, key: string) => {
  // Guard against invalid values
  if (
    !isFinite(daysToComplete) ||
    daysToComplete <= 0 ||
    daysToComplete > 1000
  ) {
    return null
  }

  return Array.from({ length: daysToComplete }, (_, i) => (
    <div
      key={`tick-${i}-${key}`}
      style={{
        position: "absolute",
        left: `${(i / daysToComplete) * 100}%`,
        bottom: 0,
        height: "20%",
        width: 1,
        backgroundColor: "rgba(255, 255, 255, 0.5)",
      }}
    />
  ))
}

const ProjectTimelineSegment = ({
  project,
  onClick,
  index,
  effectiveDays,
  left,
  style,
}: {
  project: ProjectConstructor
  onClick: (project: ProjectConstructor) => void
  index: number
  effectiveDays: number
  numberOfSessions: number
  left: number
  style: CSSProperties
}) => {
  const daysToComplete = parseInt(project.daysToComplete)
  const widthPercent = (daysToComplete / effectiveDays) * 100

  return (
    <Draggable draggableId={project.id} index={index}>
      {(dragProvided: DraggableProvided) => (
        <div
          ref={dragProvided.innerRef}
          {...dragProvided.draggableProps}
          {...dragProvided.dragHandleProps}
          style={{
            ...style,
            ...dragProvided.draggableProps.style,
            left: `${left}%`,
            width: `${widthPercent}%`,
            borderRight: "1px solid white",
            position: "absolute",
            top: 0,
          }}
          onClick={() => onClick(project)}
        >
          {createDayTicks(daysToComplete, project.id)}
          <SLabel>{project.name}</SLabel>
        </div>
      )}
    </Draggable>
  )
}

export default ProjectTimelineSegment
